<template>
  <power-bi code="eyJrIjoiZDYxNmI1MDAtNjhlZC00Mzc5LTkzMmQtMDkzZmU2MDg0YmU3IiwidCI6ImM4NDJjMWQ5LWQzNjQtNDcxNi1iN2UzLWNhNDgxYTIzZDZhYyJ9" />
</template>

<script>
import PowerBi from '../components/PowerBi.vue';

export default {
    components: {
        PowerBi,
    },
};
</script>
